export default __webpack_public_path__ + "locales/tr/PDFFormDialog.json?hash=58e9a12380cb9ccd17aa4ae53a9215c3";